import {BonusBunniesZeppelinView} from "./BonusBunniesZeppelinView";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {BonusBunniesGameMode} from "../gamemode/BonusBunniesGameMode";
import {ScreenEvent} from "@nolimitcity/slot-game/bin/core/screen/event/ScreenEvent";

export class BonusBunniesZeppelinController {

    private _view:BonusBunniesZeppelinView;
    private _mode:string;
    private _nextMode:string;
    private _onGameStart:boolean = false;
    private _retriggerAnimation:boolean = true;

    constructor() {
        this.addEventListeners();
        this._view = new BonusBunniesZeppelinView();
        this._view.callBack = () => this.zeppelinAnimationComplete();
    }

    private addEventListeners():void {
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event:GameEvent) => this.onDataParsed(event.params[0]));
        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event:GameEvent) => this.onDataParsed(event.params[0]));
        EventHandler.addEventListener(this, ScreenEvent.GAME_START, () => this.onGameStart());
    }

    private onDataParsed(data:ParsedGameData):void {
        //Run Base Game or Bonus Game Zeppelin
        this._mode = data.mode;
        this._nextMode = data.nextMode;
        //Making sure normal zeppelin isn't triggered at the end of Bonus round
        if(this._mode == BonusBunniesGameMode.BONUS_GAME && this._nextMode == BonusBunniesGameMode.NORMAL) {
            this._retriggerAnimation = false;
        }
    }

    private onGameStart():void {
        if(this._onGameStart == false) {
            this._onGameStart = true;
            this._view.activated = true;
            this.restartZeppelinAnimation(true);
        }
    }

    private zeppelinAnimationComplete():void {
        this.restartZeppelinAnimation();
    }

    //When you enter or exit Bonus game
    public abortZeppelinanimation():void {
        this._view.abort();
    }

    public restartZeppelinAnimation(forceStart:boolean = false):void {
        if(this._retriggerAnimation == false) {
            return;
        }
        let isBaseGame:boolean = false;
        if(this._nextMode == BonusBunniesGameMode.NORMAL) {
            isBaseGame = true;
        }
        this._view.playZeppelinAnimation(isBaseGame, forceStart);
    }

    set retriggerAnimation(value:boolean) {
        this._retriggerAnimation = value;
    }
}